"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesTitleWrap = exports.SmallTitleWrap = exports.DefaultTitleWrap = exports.LargeTitleWrap = exports.BigTitleWrap = exports.MaxTitleWrap = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var styles_1 = require("@material-ui/styles");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    MaxTitle: function (newType) { return ({
        height: 44,
        display: "flex",
        alignItems: "center",
        justifyContent: newType.justifyContent,
        width: "100%",
        fontSize: 36,
        fontWeight: 700,
        color: theme ? theme.app.Setting.color3 : "",
    }); },
    BigTitle: function (newType) { return ({
        height: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: newType.justifyContent,
        width: "100%",
        fontSize: 24,
        fontWeight: 700,
        color: theme ? theme.app.Setting.color3 : "",
    }); },
    LargeTitle: function (newType) { return ({
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: newType.justifyContent,
        width: "100%",
        fontSize: 20,
        fontWeight: 400,
        color: theme ? theme.app.Setting.color3 : "",
    }); },
    DefaultTitle: function (newType) { return ({
        height: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: newType.justifyContent,
        width: "100%",
        fontSize: 16,
        fontWeight: 600,
        color: theme ? theme.app.Setting.color3 : "",
    }); },
    SmallTitle: function (newType) { return ({
        height: 20,
        display: "flex",
        alignItems: "center",
        justifyContent: newType.justifyContent,
        width: "100%",
        fontSize: 14,
        fontWeight: 400,
        color: theme ? theme.app.SmallTitle.color : "",
    }); },
    DesTitle: function (newType) { return ({
        height: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: newType.justifyContent,
        width: "100%",
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 4,
        color: theme ? theme.app.DesTitle.color : "",
    }); },
}); });
function MaxTitleWrap(props) {
    var position = props.position, children = props.children;
    var newType = {
        justifyContent: position,
    };
    var classes = useStyles(newType);
    return React.createElement("div", { className: classes.MaxTitle }, children);
}
exports.MaxTitleWrap = MaxTitleWrap;
function BigTitleWrap(props) {
    var position = props.position, children = props.children;
    var newType = {
        justifyContent: position,
    };
    var classes = useStyles(newType);
    return React.createElement("div", { className: classes.BigTitle }, children);
}
exports.BigTitleWrap = BigTitleWrap;
function LargeTitleWrap(props) {
    var position = props.position, children = props.children;
    var newType = {
        justifyContent: position,
    };
    var classes = useStyles(newType);
    return (React.createElement("div", null,
        React.createElement("div", { className: classes.LargeTitle }, children),
        ";"));
}
exports.LargeTitleWrap = LargeTitleWrap;
function DefaultTitleWrap(props) {
    var position = props.position, children = props.children, style = props.style;
    var newType = {
        justifyContent: position,
    };
    var classes = useStyles(newType);
    return (React.createElement("div", null,
        React.createElement("div", { className: classes.DefaultTitle, style: style }, children)));
}
exports.DefaultTitleWrap = DefaultTitleWrap;
function SmallTitleWrap(props) {
    var position = props.position, children = props.children;
    var newType = {
        justifyContent: position,
    };
    var classes = useStyles(newType);
    return React.createElement("div", { className: classes.SmallTitle }, children);
}
exports.SmallTitleWrap = SmallTitleWrap;
function DesTitleWrap(props) {
    var position = props.position, children = props.children;
    var newType = {
        justifyContent: position,
    };
    var classes = useStyles(newType);
    return React.createElement("div", { className: classes.DesTitle }, children);
}
exports.DesTitleWrap = DesTitleWrap;
MaxTitleWrap.protoTypes = {
    position: PropTypes.string,
};
MaxTitleWrap.defaultProps = {
    position: "flex-start",
};
//# sourceMappingURL=TitleWrap.js.map